var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDownLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2915 8.33333C12.2915 8.67851 12.0117 8.95833 11.6665 8.95833H1.6665C1.32133 8.95833 1.0415 8.67851 1.0415 8.33333C1.0415 7.98816 1.32133 7.70833 1.6665 7.70833H11.6665C12.0117 7.70833 12.2915 7.98816 12.2915 8.33333Z",
    fill: "#9897A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95817 11.6667C8.95817 12.0118 8.67835 12.2917 8.33317 12.2917H1.6665C1.32133 12.2917 1.0415 12.0118 1.0415 11.6667C1.0415 11.3215 1.32133 11.0417 1.6665 11.0417H8.33317C8.67835 11.0417 8.95817 11.3215 8.95817 11.6667Z",
    fill: "#9897A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62484 15C5.62484 15.3452 5.34502 15.625 4.99984 15.625H1.6665C1.32133 15.625 1.0415 15.3452 1.0415 15C1.0415 14.6548 1.32133 14.375 1.6665 14.375H4.99984C5.34502 14.375 5.62484 14.6548 5.62484 15Z",
    fill: "#9897A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6248 5C15.6248 5.34518 15.345 5.625 14.9998 5.625H1.6665C1.32133 5.625 1.0415 5.34518 1.0415 5C1.0415 4.65482 1.32133 4.375 1.6665 4.375H14.9998C15.345 4.375 15.6248 4.65482 15.6248 5Z",
    fill: "#9897A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3912 17.1086C15.6353 17.3527 16.031 17.3527 16.2751 17.1086L18.7751 14.6086C19.0192 14.3645 19.0192 13.9688 18.7751 13.7247C18.531 13.4806 18.1353 13.4806 17.8912 13.7247L16.4582 15.1578V8.33333C16.4582 7.98816 16.1783 7.70833 15.8332 7.70833C15.488 7.70833 15.2082 7.98816 15.2082 8.33333V15.1578L13.7751 13.7247C13.531 13.4806 13.1353 13.4806 12.8912 13.7247C12.6472 13.9688 12.6472 14.3645 12.8912 14.6086L15.3912 17.1086Z",
    fill: "#9897A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDownLight);
export default __webpack_public_path__ + "static/media/sort-down-light.99754e6ea5235d054f120c9f3d51c6b6.svg";
export { ForwardRef as ReactComponent };